import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { WidgetModule } from '../widget';
import { MessagesModule } from './messages/messages.module';
import { TutorizationQuestionService } from './group-questions/services/tutorization-question.service';
import { ChoicesService } from './group-questions/services/choices.service';
import { TutorizationGroupService } from './group-questions/services/tutorization-group.service';
import { GroupQuestionsListComponent } from './group-questions/group-questions-list/group-questions-list.component';
import { TutorizationRoutingModule } from './tutorization-routing.module';
import { GroupQuestionEditorComponent } from './group-questions/group-question-editor/group-question-editor.component';
import { GroupQuestionDetailComponent } from './group-questions/group-question-detail/group-question-detail.component';
import { GroupQuestionsListRowComponent } from './group-questions/group-questions-list/group-questions-list-row/group-questions-list-row.component';
import { GroupQuestionCreateComponent } from './group-questions/group-question-create/group-question-create.component';
import { GroupQuestionsComponent } from './group-questions/group-questions.component';
import { MarsTutorizationComponent } from './mars-tutorization/mars-tutorization.component';
import { TutorizationService } from './tutorization.service';

import {
  DebatesComponent,
  DebatesListComponent,
  DebatesListRowComponent,
  DebateDetailComponent,
  DebateOpinionsListComponent,
  DebateOpinionsListRowComponent
} from './debates';
@NgModule({
  imports: [MessagesModule, CommonModule, CoreModule, WidgetModule, TutorizationRoutingModule],
  declarations: [
    GroupQuestionsListComponent,
    GroupQuestionEditorComponent,
    GroupQuestionDetailComponent,
    GroupQuestionsListRowComponent,
    GroupQuestionCreateComponent,
    GroupQuestionsComponent,
    DebatesComponent,
    DebatesListComponent,
    DebatesListRowComponent,
    DebateDetailComponent,
    DebateOpinionsListComponent,
    DebateOpinionsListRowComponent,
    MarsTutorizationComponent
  ],
  exports: [
    MarsTutorizationComponent,
    GroupQuestionsListComponent,
    GroupQuestionsComponent,
    DebatesComponent,
    DebatesListComponent,
    DebateDetailComponent,
    MessagesModule
  ],
  providers: [TutorizationService, TutorizationQuestionService, ChoicesService, TutorizationGroupService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TutorizationModule {}
